export default {
  selected: 'Seleccionado',
  deselect_all_selected_options:
    'Deseleccionar todas las opciones seleccionadas',
  expanded: 'Expandido',
  collect: 'Recolectar',
  no_options_available: 'No hay opciones disponibles',
  required: 'Requerido',
  input_clear_aria_label: 'Borrar entrada',
  input_show_hide_password_aria_label: 'Mostrar u ocultar contraseña',
  input_increment_aria_label: 'Aumentar valor',
  input_decrement_aria_label: 'Reducir valor',
  english: 'Inglés',
  chinese: 'Chino',
  portuguese: 'Portugués',
  spanish: 'Español',
  dutch: 'Neerlandés',
  french: 'Francés',
  german: 'Alemán',
  russian: 'Ruso',
  ukrainian: 'Ucraniano',
  korean: 'Coreano',
  italian: 'Italiano',
  czech: 'Checo',
  access_your_account: 'Accede a tu cuenta',
  use_your_company_credentials_to_get_started:
    'Utilice sus credenciales de empresa para empezar',
  this_link_has_expired: 'Este enlace ha expirado',
  login: 'Iniciar sesión',
  sample_no_production_date_message:
    'Se debe seleccionar la fecha de fabricación',
  free_comment: 'Atributo libre',
  save_comments: 'Guardar y Cerrar',
  round_list_rounds: 'Rondas',
  round_edit_round: 'Editar Ronda',
  round_new_round: 'Nueva Ronda',
  round_remove_round: '¿Está seguro de que desea eliminar la Ronda?',
  round_schedule: 'Programación',
  round_tasters_unselect_all: 'Deseleccionar todos los catadores',
  round_tasters_select_all: 'Seleccionar todos los catadores',
  round_close: 'Cerrar Ronda',
  round_close_message: '¿Está seguro de que desea completar esta ronda?',
  round_create_site_message: '¡Está creando una ronda que no es de su planta!',
  round_closed_message: 'Las rondas concluidas no se pueden editar',
  round_status_created: 'Creado',
  round_status_samples: 'Muestras',
  round_status_scheduled: 'Programada',
  round_status_tasters: 'Catadores',
  round_status_in_progress: 'En Progreso',
  round_status_finished: 'Terminado',
  round_status_closed: 'Concluida',
  round_schedule_start_finish_date:
    'La fecha de inicio no puede ser mayor que la fecha de finalización',
  round_schedule_finish_date_no_start_date:
    'Primero debes seleccionar una fecha de inicio',
  round_disabled_discussion_tooltip:
    'No puedes ir a una Discusión de una ronda inconclusa.',
  round_up_down_maintenance_tooltip:
    'Esta funcionalidad está en mantenimiento y está temporalmente no disponible',
  round_delete_other_users_rounds:
    'No tienes permiso para eliminar una Ronda que no has creado',
  round_randomize_samples_order_button: 'Barajar',
  round_block_results_tooltip:
    'Bloquea los resultados de esta ronda para que no se descarguen en la pantalla de informes. Si el botón está deshabilitado, no tiene el privilegio de bloquear los resultados de las rondas desde esta ubicación.',
  round_block_results_confirm:
    '¿Está seguro de que desea bloquear/desbloquear los resultados de la ronda?',
  round_block_results_no_privilege:
    'No tiene el privilegio de bloquear/desbloquear los resultados de la ronda desde esta ubicación.',
  sample_list_samples: 'Muestras',
  sample_edit_sample: 'Editar Muestra',
  sample_new_sample: 'Nueva Muestra',
  sample_remove_sample: 'Eliminar Muestra',
  sample_upload_document: 'Cargar documentos',
  sample_download_documents: 'Documentos de muestra',
  sample_tasted_dates: 'Fecha de degustación',
  sample_upload_message: 'Para cargar varios documentos, agréguelos a un .zip',
  sample_not_for_kpi: 'No es para el KPI',
  sample_package: 'Envase',
  sample_volume: 'Volumen',
  sample_production_date: 'Fecha de Producción',
  sample_expire_date: 'Fecha de vencimiento',
  sample_trial_identifier: 'Identificador de prueba',
  sample_project_name: 'Nombre del proyecto',
  sample_linked: 'Vinculado a una ronda',
  sample_expire_bigger_than_production:
    'La Fecha de Producción no puede ser mayor que la Fecha de Vencimiento',
  sample_no_site_message:
    'Es obligatorio seleccionar una Zona, un País y una Planta para crear una muestra.',
  sample_no_brand_message: 'Es obligatorio seleccionar una Marca',
  sample_duplicated_kpi_message:
    'Ya existe un KPI para el mes, la marca y la planta que seleccionó y no podrá guardar',
  sample_duplicated_kpi_message_quarter:
    'Ya existe un KPI para el trimestre, la marca y el sitio que ha seleccionado, por lo que no podrá guardarlo.',
  sample_duplicated_project_message:
    'Ya existe una muestra con este nombre de proyecto e identificador de prueba para esta planta y marca, y no podrá guardar',
  sample_project_no_name_or_trial:
    'El nombre del proyecto y el identificador de prueba son obligatorios al crear una muestra del tipo de proyecto.',
  sample_production_to_project_confirm_message:
    'Está cambiando el tipo de esta muestra de PRODUCCIÓN a PROYECTO. ¿Desea continuar?',
  sample_project_to_production_confirm_message:
    'Está cambiando el tipo de esta muestra de PROYECTO a PRODUCCIÓN. ¿Desea continuar?',
  sample_no_volume_message:
    'El envase y el volumen son obligatorios al crear/editar una muestra.',
  sample_id_code_message: 'Incluya el número de lote completo',
  sample_show_all_samples_hint:
    'Mostrando muestras creadas hasta dentro de un año. Marque esta casilla si también desea ver muestras más antiguas',
  sample_show_all_samples_label: 'Mostrar todas las muestras',
  package_duplicate: 'Ya hay un envase con este nombre',
  common_production: 'Producción',
  day: 'día',
  common_project: 'Proyecto',
  group_list_groups: 'Grupos',
  group_edit_group: 'Editar Grupo',
  group_new_group: 'Nuevo Grupo',
  group_remove_group: 'Eliminar Grupo',
  group_close_modal: 'Finalizar',
  group_duplicated_user: '¡Este usuario ya ha sido agregado a este grupo!',
  group_no_name_message: 'Es necesario ingresar un nombre de grupo',
  group_no_zone_message: 'Es necesario seleccionar una zona',
  group_no_users_message: 'Es necesario seleccionar al menos un catador',
  family_list_families: 'Estilos',
  family_edit_family: 'Editar Estilo',
  family_new_family: 'Nuevo Estilo',
  family_remove_family: 'Eliminar Estilo',
  families_page_description:
    'Administre todos los estilos y sus configuraciones en un solo lugar',
  family_new_page_description:
    'Complete la información del estilo y finalice la creación.',
  family_edit_page_description: 'Edite la información del estilo.',
  family_save_success: '¡Estilo creado con éxito!',
  family_update_success: '¡Estilo actualizado con éxito!',
  family_save_failed: 'Error al guardar el estilo.',
  family_save_success_desc: 'Revíselo en los estilos a continuación.',
  family_update_success_desc: 'Revíselo en los estilos a continuación.',
  family_save_failed_desc: 'Inténtelo de nuevo en un momento.',
  the_name_is_duplicated: 'El nombre está duplicado.',
  common_style_name: 'Nombre del Estilo',
  common_warning: 'Advertencia',
  cancel_new_family_title: '¿Cancelar nuevo estilo?',
  cancel_edit_family_title: '¿Cancelar edición del estilo?',
  cancel_new_family_confirm: 'Cancelar nuevo estilo',
  cancel_edit_family_confirm: 'Cancelar edición del estilo',
  family_remove_success: 'Estilo eliminado correctamente',
  family_remove_failed: 'Error al eliminar estilo',
  family_delete_title: '¿Eliminar estilo?',
  family_delete_description:
    'El estilo {{name}} se eliminará permanentemente. ¿Está seguro de que desea continuar?',
  family_delete_success: '¡Estilo eliminado con éxito!',
  family_delete_success_desc: 'El estilo ha sido eliminado.',
  family_delete_failed: 'Error al eliminar el estilo.',
  family_delete_failed_desc: 'Inténtelo de nuevo en un momento.',
  family_has_no_english_name:
    'Es obligatorio tener el nombre del estilo en inglés',
  brand_list_brands: 'Marcas',
  brand_edit_brand: 'Editar Marca',
  brand_new_brand: 'Nueva Marca',
  brand_remove_brand: 'Eliminar Marca',
  brand_profile_picture: 'Cargar la Imagen del perfil de la cerveza',
  brand_upload_brand_logo: 'Cargar el logo de la Marca',
  brand_duplicate: 'Aviso: ya existe una cerveza con este nombre',
  brand_has_no_english_name:
    'Debe completar un nombre de marca y un perfil de cerveza correspondiente',
  brand_upload_help_message: 'Solo archivos PNG y JPG',
  brand_has_no_product_type: 'Debe seleccionar un tipo de producto',
  package_list_packages: 'Envases',
  package_edit_package: 'Editar Envase',
  package_new_package: 'Nuevo Envase',
  package_remove_package: 'Eliminar Envase',
  packages_page_description:
    'Gestiona todos los tipos de envases y sus configuraciones en un solo lugar.',
  comments_page_description:
    'Gestiona todos los atributos y sus configuraciones en un solo lugar.',
  comments_new_page_description:
    'Complete la información del atributo y finalice la creación.',
  comments_edit_page_description:
    'Edita la información del atributo y completa la actualización.',
  comment_attribute_name: 'Nombre del atributo de sabor',
  comment_select_category: 'Seleccione la categoría de sabor',
  packages_edit_page_description:
    'Edita la información del envase y completa la actualización.',
  package_successfully_created: '¡Envase creado con éxito!',
  package_successfully_created_desc: 'Revíselo en los envases a continuación.',
  package_successfully_updated: '¡Envase actualizado con éxito!',
  package_successfully_updated_desc: 'Revíselo en los envases a continuación.',
  packages_new_page_description:
    'Complete la información del envase y finalice la creación.',
  package_name: 'Nombre del envase',
  content_already_exists: 'El contenido ya existe.',
  language_english: 'Inglés',
  language_chinese: 'Chino',
  language_portuguese: 'Portugués',
  language_spanish: 'Español',
  language_dutch: 'Holandés',
  language_french: 'Francés',
  language_german: 'Alemán',
  language_russian: 'Ruso',
  language_ukrainian: 'Ucraniano',
  language_korean: 'Coreano',
  language_italian: 'Italiano',
  package_has_no_english_name:
    'Es obligatorio tener el nombre del Envase en inglés',
  package_volumes: 'Volúmenes',
  package_new_volume: 'Nuevo Volumen',
  package_remove_volume: 'Eliminar Volumen',
  degree_list_degrees: 'Intensidades',
  degree_edit_degree: 'Editar Intensidad',
  degree_new_degree: 'Nueva Intensidad',
  degree_remove_degree: 'Eliminar Intensidad',
  category_list_categories: 'Categorías',
  category_edit_category: 'Editar categoría de sabor',
  category_new_category: 'Nueva categoría de sabor',
  category_remove_category: 'Eliminar categoría de sabor',
  comment_list_comments: 'Atributos',
  comment_edit_comment: 'Editar atributo de sabor',
  comment_new_comment: 'Nuevo atributo de sabor',
  comment_remove_comment: 'Eliminar atributo de sabor',
  comment_cancel_new_title: '¿Cancelar nuevo atributo de sabor?',
  comment_cancel_edit_title: '¿Cancelar edición del atributo de sabor?',
  comment_cancel_new_confirm: 'Cancelar nuevo atributo de sabor',
  comment_cancel_edit_confirm: 'Cancelar edición del atributo de sabor',
  comment_successfully_created: '¡Atributo de sabor creado correctamente!',
  comment_successfully_created_desc: 'Consúltalo en el atributo a continuación.',
  comment_successfully_updated: '¡Atributo de sabor actualizado correctamente!',
  comment_successfully_updated_desc: 'Consúltalo en el atributo a continuación.',
  comment_create_failed: 'No se pudo crear el atributo de sabor.',
  comment_update_failed: 'No se pudo actualizar el atributo de sabor.',
  comment_failed_desc: 'Vuelve a intentarlo en un momento.',
  comment_delete_title: '¿Eliminar atributo?',
  comment_delete_description:
    'El atributo {{name}} se eliminará permanentemente. ¿Estás seguro de que quieres continuar?',
  comment_delete_success: '¡Atributo eliminado correctamente!',
  comment_delete_success_desc: 'Consúltalo en el atributo a continuación.',
  comment_delete_failed: 'No se pudo eliminar el atributo.',
  comment_delete_failed_desc: 'Vuelve a intentarlo en un momento.',
  user_list_users: 'Usuarios',
  user_edit_user: 'Editar Usuario',
  user_new_user: 'Nuevo contratista de ABI',
  user_export_users: 'Exportar usuarios',
  user_list_profiles: 'Perfiles',
  user_profile_name: 'Nombre del perfil',
  user_profile_select: 'Seleccione un perfil',
  user_profile_remove: 'Eliminar perfil',
  user_profile_save: 'Guardar perfil',
  user_remove_user: 'Eliminar usuario',
  user_use_terms: 'Términos de uso aceptados',
  report_list_report: 'Informes',
  report_start_date: 'Fecha de inicio',
  report_end_date: 'Fecha de conclusión',
  common_average_key_score: 'Puntuación clave promedio',
  common_score: 'Puntuación',
  common_privileges: 'Permisos',
  common_abi_name: 'Nombre ABI',
  common_id: 'ID',
  common_ranked: 'Clasificado',
  common_week: 'Semana',
  common_weeks: 'Semanas',
  common_days: 'Días',
  common_category: 'Categoría de sabor',
  common_category_sample: 'Categoría',
  common_degree: 'Intensidad',
  common_comment: 'Atributo de sabor',
  common_status: 'Estado',
  common_zone: 'Zona',
  common_country: 'País',
  common_site: 'Planta',
  common_start_date: 'Fecha de Inicio',
  common_finish_date: 'Fecha de Finalización',
  common_round_type: 'Tipo de prueba',
  common_type: 'Tipo',
  common_round: 'Ronda',
  common_round_id: 'ID Ronda',
  common_tasters: 'Catadores',
  common_sample_performance: 'Rendimiento de muestra',
  common_taste: 'Sabor',
  common_key_taster: 'Catador principal',
  common_sample: 'Muestra',
  common_samples: 'Muestras',
  common_sample_type: 'Tipo de muestra',
  common_family: 'Estilo',
  common_brand: 'Marca',
  common_product_type: 'Tipo de Producto',
  common_temperature: 'Condiciones de almacenamiento',
  common_storage_times: 'Tiempo de Almacenamiento',
  common_sku: 'SKU',
  common_batch: 'ID Código',
  common_kpi_month: 'KPI Mes',
  common_logo: 'Logo',
  common_name: 'Nombre',
  common_notes: 'Notas',
  common_email: 'Correo electrónico',
  common_language: 'Idioma',
  common_terms_of_use: 'Términos de uso',
  common_new: 'Nuevo',
  common_profile: 'Perfil',
  common_filter: 'Filtrar usuarios',
  common_download: 'Descargar',
  download: 'Descargar',
  common_save: 'Guardar',
  common_cancel: 'Cancelar',
  cancel_add_taster_title: '¿Cancelar la adición del catador?',
  cancel_add_taster_description:
    'Ya has seleccionado catadores. Al cancelar se descartará tu selección. ¿Quieres continuar?',
  cancel_add_taster_confirm: 'Cancelar la adición del catador',
  cancel_enter_concentration_title: '¿Cancelar la introducción de la concentración?',
  cancel_enter_concentration_description:
    'Has introducido un valor de concentración. Al cancelar se descartará el dato no guardado. ¿Quieres continuar?',
  cancel_enter_concentration_confirm: 'Cancelar la introducción de la concentración',
  cancel_new_package_title: '¿Cancelar nuevo envase?',
  cancel_edit_package_title: '¿Cancelar edición del envase?',
  cancel_new_package_confirm: 'Cancelar nuevo envase',
  cancel_edit_package_confirm: 'Cancelar edición del envase',
  common_search_users: 'Buscar Usuarios',
  common_search_group: 'Buscar Grupo',
  common_search_taster: 'Buscar Catador',
  common_no_data: 'No hay datos para mostrar',
  common_edit: 'Editar',
  no_results_found_for_applied_filters:
    'No se encontraron resultados para los filtros aplicados',
  common_loading: 'Cargando...',
  common_search: 'Buscar...',
  type_more_characters: 'Escriba {{count}} carácter(es) más...',
  common_cannot_be_empty: '{{field}} no puede estar vacío',
  common_select_option: 'Seleccionar opción…',
  search_placeholder: 'Buscar...',
  no_search_results: 'No se encontraron resultados',
  clear_selection: 'Borrar selección',
  common_per_page: 'Líneas por página',
  common_attributes: 'Atributos',
  common_not_started: 'No Iniciado',
  common_in_progress: 'En Progreso',
  common_finished: 'Terminada',
  common_start: 'Inicio',
  common_detail: 'Ver detalles',
  common_delete: 'Eliminar',
  common_position: 'Posición',
  common_score_scale: 'Escala de Puntuación',
  common_intensity: 'Intensidad',
  common_report_not_have_data: 'Las rondas seleccionadas no tuvieron votos',
  month_0: 'Enero',
  month_1: 'Febrero',
  month_2: 'Marzo',
  month_3: 'Abril',
  month_4: 'Mayo',
  month_5: 'Junio',
  month_6: 'Julio',
  month_7: 'Agosto',
  month_8: 'Septiembre',
  month_9: 'Octubre',
  month_10: 'Noviembre',
  month_11: 'Diciembre',
  dropdown_change_picture: 'Cambiar imagen',
  dropdown_language: 'Idioma',
  dropdown_logout: 'Cerrar sesión',
  logout_title: 'Cerrando sesión, espere por favor…',
  logout_description: 'Se está cerrando la sesión de su cuenta.',
  round_not_started: 'No Iniciado',
  round_in_progress: 'En Progreso',
  round_finished: 'Terminada',
  round_filter_start: 'Inicio',
  tasting_list_rounds: 'Listado de Rondas',
  menu_tasting_session: 'Sesión de cata',
  menu_panel_management: 'Gestión de Paneles',
  menu_process_management: 'Gestión de Proceso',
  menu_product_management: 'Gestión de Productos',
  menu_attributes_management: 'Gestión de Atributos',
  tasting_finish_sample: 'Finalizar Muestra',
  tasting_comments: 'Comentarios',
  tasting_beer_profile: 'Perfil de cerveza',
  tasting_need_select_score_comments:
    'Debe establecer una puntuación y agregar al menos un comentario para continuar...',
  tasting_finish_taste: 'Finalizar Degustación',
  tasting_finish_tasting: 'Finalizar Degustación',
  common_no_comments: 'Sin comentarios',
  previous_comments: 'Comentarios anteriores',
  review_submit_title: '¿Está listo para enviar los resultados?',
  review_submit_description: 'No podrás editar esto más tarde',
  review_finish_taste: 'Concluir degustación',
  review_warning_sample_title: '¡Tiene muestras sin degustar!',
  review_warning_sample_description: '¿Quiere continuar sin probarlas?',
  review_warning_sample_review: 'Revisar',
  review_warning_sample_ok: 'Continuar',
  review_warning_preference_description:
    'Por favor, seleccione una preferencia antes de continuar.',
  review_warning_tie_sample_title: '¡Tiene muestras empatadas!',
  review_warning_tie_sample_description:
    '¡No puede continuar sin clasificarlas!',
  review_warning_tie_sample_review: 'Revisión',
  common_submit: 'Enviar',
  common_discussion: 'Discusión',
  discussion_order_number: 'Ordenar por posición',
  discussion_order_brewery: 'Ordenar por cervecería',
  discussion_order_ranking: 'Ordenar por clasificación',
  discussion_order_brand: 'Ordenar por marca',
  discussion_order_score: 'Ordenar por puntuación',
  discussion_order_key_score: 'Ordenar por puntuación clave',
  discussion_order_overall_rank: 'Ordenar por puntaje de clasificación general',
  discussion_order_key_rank: 'Ordenar por clasificación clave',
  discussion_key_ranking: 'Clasificación clave',
  discussion_export_error: '¡No se pudo guardar el archivo!',
  discussion_ranking: 'Clasificación',
  discussion_overall_ranking: 'Clasificación general',
  common_brewery: 'Cervecería',
  common_trial_identifier: 'ID Prueba',
  common_key_score: 'Puntaje Clave',
  round_report: 'Exportar a Excel',
  common_comments: 'Comentarios',
  message_you_cannot_delete_all_comments:
    'No puede eliminar todos los comentarios al editar un voto!',
  common_message_empty_profile:
    'No se permite el nombre del perfil vacío o en blanco',
  common_message_out_score_range: 'Puntuación fuera de rango',
  tasting_need_select_score: '¡Primero debe establecer una puntuación!',
  common_category_name: 'Categoría',
  categories_new_category: 'Nueva Categoría',
  categories_remove_category: '¿Realmente desea eliminar la Categoría?',
  categories_list_categories: 'Listado de Categorías',
  categories_list_all_categories: 'Todas las Categorías',
  common_category_sample_name: 'Muestras',
  categories_new_category_sample: 'Nueva Muestra',
  categories_remove_category_sample: '¿Realmente desea eliminar la Muestra?',
  categories_list_categories_samples: 'Listado de Muestras',
  common_duplicate: 'Duplicado',
  common_collection_point: 'Punto de recolección',
  common_collection_date: 'Fecha de recolección',
  common_brew_number: 'Número de fermentación/MES',
  common_need_explain_nok: '¡No puede tener muestras NOK sin un comentario!',
  common_percent_ok: 'Porcentaje OK',
  common_show_all: 'Mostrar todo',
  common_import: 'Importar',
  common_download_template: 'Descargar plantilla',
  sample_import_message: 'xlsx',
  common_template: 'Plantilla',
  common_yes: 'Sí',
  common_no: 'No',
  common_only_kpi_sample: 'Solo Muestra KPI',
  common_need_volte_first: '¡No puede comentar muestras sin votar primero!',
  common_name_template: 'Nombre de la plantilla',
  interaction_log: 'Registro de interacción',
  common_message_zone_empty: 'Zona no puede estar vacía',
  common_message_country_empty: 'País no puede estar vacío',
  common_message_site_empty: 'Planta no puede estar vacía',
  user_new_profile_save: 'Nuevo Perfil creado',
  common_in_privileges: 'en Privilegios',
  common_download_files: 'Descargar archivos',
  common_create_action: 'Crear acción',
  common_action_list: 'Lista de acciones',
  common_create_action_description:
    'Complete los detalles de la acción para esta muestra.',
  common_optional: 'opcional',
  action_deadline: 'Fecha límite',
  action_description: 'Descripción de la acción',
  action_description_autofill_tooltip: 'Descripción de la acción',
  action_description_autofill_tooltip_description:
    'Generado automáticamente (ID de ronda / Cervecería / Nombre de la muestra / Fecha de producción / Usuario creador) + descripción adicional',
  action_owner: 'Responsable',
  action_meeting: 'Reunión del registro de interacción',
  action_meeting_list: 'Reunión IAL',
  action_producing_site: 'Planta productora',
  action_production_date: 'Fecha de producción',
  action_closed_time: 'Hora de cierre',
  action_meeting_placeholder: 'Por favor, seleccione una reunión',
  action_status: 'Estado',
  action_status_draft: 'Borrador',
  action_status_not_started: 'No iniciado',
  action_status_in_progress: 'En progreso',
  action_status_delayed: 'Retrasado',
  action_status_close: 'Cerrar',

  action_menu_close: 'Cerrar',
  common_view_details: 'Ver detalles',
  action_cancel: 'Cancelar',
  action_add_comment: 'Añadir comentario',
  action_status_canceled: 'Cancelado',
  status_record: 'Registro de Estado',
  no_status_record: 'Sin registros de estado',
  action_type: 'Tipo de acción',
  action_create_user: 'Usuario creador',
  action_create_time: 'Fecha de creación',
  action_creator: 'Creador',
  action_root_cause: 'Causa raíz',
  action_description_placeholder:
    'Por favor, ingrese la descripción de la acción...',
  action_root_cause_placeholder: 'Por favor, ingrese la causa raíz...',
  action_comment_added: 'Comentario agregado exitosamente',
  action_comment_add_failed: 'No se pudo agregar el comentario',
  action_comment_placeholder: 'Ingrese su comentario...',
  action_status_changed_with_comment: 'Estado cambiado con comentario',
  required_comment_banner:
    'Como no eres el propietario de esta acción, es necesario proporcionar un comentario en nombre del propietario.',
  cancel_and_comment: 'Cancelar y comentar',
  close_and_comment: 'Cerrar y comentar',
  action_edit_action: 'Editar acción',
  action_owner_placeholder: 'Por favor, seleccione un responsable',
  action_created_successfully: '¡La acción fue creada con éxito!',
  action_created_successfully_desc:
    'Consulte la acción creada en la lista de acciones.',
  action_updated_successfully: '¡La acción fue actualizada con éxito!',
  action_updated_successfully_desc:
    'Consulte la acción actualizada en la lista de acciones.',
  action_create_failed: 'Hubo un problema al crear la acción',
  action_update_failed: 'Hubo un problema al actualizar la acción',
  action_save_failed_desc: 'Inténtelo de nuevo en un momento.',
  action_deleted_successfully: '¡La acción fue eliminada con éxito!',
  action_deleted_successfully_desc: 'Consúltelo en la lista de acciones.',
  action_delete_failed: 'Hubo un problema al eliminar la acción',
  delete_action_confirm_title: '¿Eliminar acción?',
  delete_action_confirm_description:
    'Esta acción se eliminará permanentemente. ¿Está seguro de que desea continuar?',
  action_added_notification: '[{{userName}}] añadió una nueva acción',
  action_updated_notification: '[{{userName}}] actualizó su acción',
  action_deleted_notification: '[{{userName}}] eliminó su propia acción',
  view_action_list: 'Ver Lista de Acciones',
  pdf_viewer: 'Visor PDF',
  common_all: 'Todos',
  common_continue: 'Continuar',
  common_minimum_score: 'Min',
  common_maximum_score: 'Max',
  common_average_score: 'Promedio',
  file_upload_fail: 'Error al cargar el archivo',
  file_upload_success_with_error:
    'La carga fue exitosa excepto por lo siguiente:',
  missing_fields: 'Campos faltantes',
  column_error: 'Error de columna',
  common_line: 'Línea',
  file_no_samples: '¡No se encontraron muestras en el archivo!',
  file_success_upload: '¡Archivo cargado exitosamente!',
  file_duplicated_kpi_project: 'KPI o proyecto duplicado',
  round_schedule_maximum_length:
    'La longitud máxima del nombre de la ronda es de 40 caracteres.',
  sample_malt_varieties: 'Variedades de malta',
  error_sample_already_in_round: 'La muestra ya está en la ronda',
  malt_varieties_has_no_english_name:
    'Debe tener al menos un nombre de variedad de malta.',
  malt_varieties_duplicate:
    'Atención: ya existe una variedad de malta con este nombre.',
  malt_varieties_remove: 'Eliminar variedad de malta',
  common_back: 'Atrás',
  common_next: 'Siguiente',
  malt_varieties_new: 'Nueva Variedad',
  malt_varieties_edit: 'Editar Variedad',
  malt_varieties_enter_name: 'Ingrese el nombre',
  malt_varieties_page_description:
    'Gestione todas las variedades de malta y sus configuraciones en un solo lugar.',
  malt_varieties_save_success: '¡Variedad de malta creada con éxito!',
  malt_varieties_save_success_desc:
    'Revíselo en las variedades de malta a continuación.',
  malt_varieties_update_success: '¡Variedad de malta actualizada con éxito!',
  malt_varieties_update_success_desc:
    'Revíselo en las variedades de malta a continuación.',
  malt_varieties_delete_title: '¿Eliminar variedad de malta?',
  malt_varieties_delete_description:
    'La variedad de malta {{name}} se eliminará permanentemente. ¿Está seguro de que desea continuar?',
  malt_varieties_delete_success: '¡Variedad de malta eliminada con éxito!',
  malt_varieties_delete_success_desc:
    'Revíselo en las variedades de malta a continuación.',
  malt_varieties_delete_failed: 'Error al eliminar la variedad de malta.',
  malt_varieties_delete_failed_desc: 'Inténtelo de nuevo en un momento.',
  cancel_new_malt_variety_title: '¿Cancelar nueva variedad de malta?',
  cancel_edit_malt_variety_title: '¿Cancelar edición de la variedad de malta?',
  cancel_new_malt_variety_confirm: 'Cancelar nueva variedad de malta',
  cancel_edit_malt_variety_confirm: 'Cancelar edición de la variedad de malta',
  reports_no_dates:
    '¡La fecha de inicio y la fecha de finalización son obligatorias!',
  reports_date_range_message:
    'El intervalo de fechas no puede ser superior a 1 año',
  round_save_select_site: 'Para guardar una ronda debe seleccionar un sitio',
  common_error: '¡Ups! Algo salió mal. Por favor, vuelva a intentarlo',
  common_horizontal: 'Horizontal',
  common_unit: 'Unidad',
  common_supplier: 'Proveedor',
  common_flavor: 'Sabor',
  concentration_of_the_base_beer: 'Concentración de la cerveza base',
  threshold_aml_method: 'Método AML (Método Ascendente de Límites)',
  threshold_component_concentration: 'Concentración de componentes',
  threshold_sample_different_help: '¿Qué muestra es diferente?',
  threshold_each_set_random_order: 'En cada conjunto, orden aleatorio.',
  threshold_select_base_beer: 'Seleccionar cerveza base',
  common_unity: 'Unidad',
  common_finish_session: 'Finalizar sesión',
  common_filters: 'Filtros',
  review_submit_threshold: '¿Está seguro de que quiere guardar?',
  threshold_coder_wrong:
    'Su código es incorrecto. ¡Por favor ingrese el código correcto!',
  threshold_didnt_enter_the_code: 'Por favor, introduzca su código',
  code: 'Código',
  threshold_samples_required: 'Se requiere cerveza base y aroma',
  threshold_information_helper_sample:
    'Para guardar la información de la muestra umbral, haga clic en el botón Guardar para conservar los cambios.',
  code_digits: 'Ingrese el código de 3 dígitos que le fue asignado',
  common_batch_code: 'Código de lote',
  threshold_sample_spiked_with:
    'En cada juego, seleccione la muestra que ha sido enriquecida con ',
  threshold_code_already_tasted:
    'Este código ya ha sido probado por otro usuario. Introduzca otro código.',
  common_kpi_brands: 'Marcas KPI',
  common_year: 'Año',
  common_new_kpi_brand: 'Nueva Marca KPI',
  common_action: 'Acción',
  kpi_brand_details_title: 'Detalles de KPI Brand',
  kpi_brand_details_description:
    'Vea información completa y el estado del proceso de aprobación.',
  approval_action: 'Acción de Aprobación',
  select_approval_action: 'Seleccione una acción de aprobación',
  reject_reason_title: 'Motivo de Rechazo',
  reject_reason_description:
    'Por favor, proporcione un motivo para el rechazo.',
  reject_reason_label: 'Motivo del rechazo',
  reject_reason_placeholder: 'Ingrese el motivo del rechazo...',
  reject_reason_placeholder_site:
    "Ingrese el motivo para rechazar este sitio '{{site}}'...",
  common_confirm: 'Confirmar',
  common_success: 'Éxito',
  common_save_failed: 'Error al guardar. Inténtelo de nuevo.',
  approval_status_saved_success: '¡Estado de aprobación guardado con éxito!',
  common_comment_by_category: 'Comentarios por Categoría',
  common_alphabetic_comment: 'Comentarios alfabéticos',
  common_name_pts_code: 'Código PTS',
  common_name_pts_code_placeholder: 'Código',
  common_name_process_item: 'Artículo de proceso',
  common_name_process_item_placeholder: 'Artículo',

  kpi_only_numbers_warning: 'Aceptar solo números en valores objetivo',
  kpi_max_number_range_warning: 'Su valor objetivo debe estar entre 1 y 9',
  kpi_already_selected_brand_warning:
    'Ha seleccionado esta marca, elija otra marca',
  kpi_no_kpi_informed_warning: 'No tiene ningún valor agregado',
  kpi_select_year_warning: 'Seleccione un año',
  kpi_select_site_warning: 'Seleccione un sitio',
  kpi_existing_configuration_warning: 'Tiene valores KPI del mismo sitio y año',
  kpi_target_empty_warning: 'Un objetivo de una de sus marcas está vacío',
  kpi_saved_successfully: '¡Sus valores se han guardado con éxito!',
  kpi_submitted_successfully: '¡Sus valores han sido enviados con éxito!',
  kpi_max_decimals_warning: 'Su valor objetivo debe tener hasta 3 decimales',
  kpi_count_as_kpi_sample: 'Contar como KPI',
  report_list_report_kpi: 'Informes KPI',
  report_list_report_taste: 'Informes de Sabor',
  select_brand_to_filter: '¡Seleccione una marca global!',
  select_year_to_filter: '¡Seleccione un año!',
  samples_uncheck_kpi_sample_tooltip:
    'Desmarque esta casilla si no desea que esta muestra cuente en el KPI',
  submission_type: 'Tipo de compromiso',
  reports_mandatory_zone_filter: 'Seleccione al menos una zona',
  custom_scale_title: 'Escala personalizada',
  custom_scale_grid_header_score: 'Puntaje',
  custom_scale_grid_header_ageind_scale: 'Escala de Envejecimiento Forzado',
  the_value_cannot_be_null: '¡El valor no puede estar vacío!',
  unique_id: 'Identificador único',
  reports_mandatory_test_type: 'Seleccione el tipo de prueba.',
  report_filter_rounds_description:
    'Debe seleccionar los campos obligatorios para cargar opciones de rondas.',
  round_reports_month_warning:
    'El período entre la fecha de inicio y la fecha de finalización debe ser de un máximo de 6 meses.',
  zone_can_not_empty: 'La región no puede estar vacía',
  error_loading_data:
    'Error al cargar datos. Verifique su conexión y vuelva a cargar.',
  beer_batch: 'Lote de cerveza',
  list_of_beers: 'Lista de cervezas',
  random: 'Aleatorio',
  preview: 'Vista previa',
  select_the_flavor: 'Seleccione el sabor',
  flavor_threshold: 'Umbral de sabor',
  input_digital_number: 'Ingrese número',
  concentration: 'Concentración',
  flavor_order: 'Orden de Sabor',
  last: 'Último',
  tasting: 'Degustación',
  tasting_page_description:
    'Realice una evaluación de catación de muestras y discuta el resultado.',
  confirmation: 'Confirmación',
  do_you_confirm_the_evaluation_of_this_sample:
    '¿Confirma la evaluación de esta muestra?',
  confirm: 'Confirmar',
  evaluate: 'Evaluar',
  correct_answer: 'Respuesta correcta',
  threshold: 'Límite',
  let_a_comment_about_the_tasting: 'Deja un comentario sobre la degustación ',
  send: 'Enviar',
  right_now: 'Inmediatamente',
  minute_ago: 'Hace un minuto',
  hour_ago: 'Hace una hora',
  day_before: 'Un día antes',
  year_ago: 'Hace un año',
  add_a_flavor: 'Añadir un sabor',
  soft_drinks: 'Bebidas sin alcohol',
  soft_drinks_brand: 'Marca objetivo de refresco',
  soft_drinks_brand_target: 'Marca objetivo de refrescos',
  column_options: 'Opciones de la columna',
  configure_table_title: 'Personalizar columnas',
  configure_table: 'Configurar tabla',
  configure_table_description: 'Elige las columnas visibles y ajusta su orden.',
  configure_table_helper:
    'Debe haber al menos 2 columnas visibles y se pueden fijar como máximo 4 columnas.',
  configure_table_fixed_left: 'Fijada a la izquierda',
  configure_table_scroll_area: 'Área de desplazamiento',
  configure_table_fixed_right: 'Fijada a la derecha',
  configure_table_empty_left:
    'Arrastra una columna aquí para fijarla a la izquierda',
  configure_table_empty_right:
    'Arrastra una columna aquí para fijarla a la derecha',
  configure_table_save: 'Guardar cambios',
  configure_table_reset: 'Restablecer valores predeterminados',
  configure_table_discard: 'Descartar cambios',
  configure_table_show: 'Mostrar',
  configure_table_hide: 'Ocultar',
  configure_table_min_visible: 'Deben quedar visibles al menos 2 columnas',
  configure_table_max_fixed: 'Puedes fijar como máximo 4 columnas',
  configure_table_drag: 'Arrastra para reordenar',
  configure_table_dragging: 'Arrastrando',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    'Seleccione cuál de las columnas desea que se muestre.',
  countdown: 'Cuenta atrás',
  less_than_five_minutes:
    'Esta sesión de degustación terminará en 5 minutos, si necesitas proceder, por favor contacta con el administrador para retrasar la fecha de finalización.',
  the_countdown_to_the_evaluation_has_ended:
    'La cuenta regresiva para comentarios ha finalizado. No se puede ingresar a los comentarios.',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    'Calcula cuánto tiempo necesitas para terminar de probar las muestras',
  only_six_flavors_can_be_added_at_most:
    '¡Sólo se pueden añadir 6 sabores como máximo!',
  concentration_of_the_flavor: 'Concentración de sabor',
  input_value: 'Valor de entrada',
  Concentration_of_the_flavor_is_required:
    'La concentración del sabor es obligatoria',
  previous_round: 'Ronda anterior',
  next_round: 'Siguiente Ronda',
  the_end_time_is_greater_than_the_current_time:
    'La hora de finalización debe ser mayor que la hora actual, si selecciona el mismo día que el día actual, seleccione primero la hora y el minuto!',
  check_the_answer_at_the_end_of_the_countdown:
    'La cuenta regresiva no ha terminado. Puede ver las respuestas después de la cuenta regresiva',
  incremental_step: 'Paso incremental',
  set3_concentration: 'Concentración Set3',
  concentration_increments_between_levels:
    'Incremento de concentración entre niveles',
  incremental_set3_concentration_required:
    'Se requiere paso incremental y concentración Set3',
  sprint: 'Sprint',
  sprint_number_greater_than_zero: 'El número de Sprint debe ser mayor que 0',
  sprint_notes_at_least_one_note:
    'Las notas de Sprint deben tener al menos una nota',
  sprint_patch_notes_success_update:
    'Notas del parche de Sprint actualizadas con éxito.',
  sprint_patch_notes_error_update: 'No fue posible guardar las notas.',
  sprint_number: 'Número de Sprint',
  sprint_patch_notes: 'Notas del parche de Sprint',
  note: 'Nota',
  select_all: 'Seleccionar todo',
  please_add_samples_first: 'Por favor agregue la muestra primero',
  reverse: 'Reversión',
  new_test: 'Nueva Prueba',
  triangle_test_name: 'Nombre de la prueba de triangulación',
  triangle_test: 'Prueba de triangulación',
  you_can_not_set_three_identical_samples:
    'No puede establecer las mismas tres opciones',
  its_mandatory_to_input_test_name:
    'Es obligatorio ingresar el nombre de la prueba.',
  its_mandatory_to_input_sample_information:
    'Es obligatorio ingresar la información de la muestra.',
  attention: 'Atención',
  test_number: 'Número de prueba',
  you_selected_the: 'Ha seleccionado',
  next_sample: 'Siguiente muestra',
  remove_triangle_test: 'Eliminar esta prueba',
  you_can_only_select_up_to_five: 'Se permite un máximo de cinco selecciones',
  test: 'Prueba',
  confirm_remove: '¿Confirmar la eliminación de la prueba?',
  reports_mandatory_zone_country_site_filter:
    '¡Se requieren regiones, países, fábricas!',
  reports_mandatory_brand_filter: 'Seleccione al menos una marca',
  reports_by_producing_site: 'Informe por planta productora',
  download_label: 'Descargar Etiqueta',
  standard: 'Valor estándar',
  input_test: 'Prueba de entrada',
  detecting: 'Detectar...',
  connected: 'Conectado',
  current_taster: 'Catador actual',
  alcohol_concentration: 'Concentración de alcohol',
  alcohol_result_submit_failed_title:
    'Se produjo un problema al enviar el resultado',
  alcohol_result_submit_failed_desc: 'Vuelve a intentarlo en un momento.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    '¡Su concentración de alcohol en la sangre es excesiva. Vuelva a realizar la prueba más tarde!',
  alcohol_test_qualified: 'Prueba de alcohol aprobada',
  alcohol_concentration_configuration: 'Configuración de la concentración de alcohol',
  breathalyzer_configuration_description:
    'Configure la concentración de alcohol de cada fábrica y el estado de conducción de los usuarios.',
  breathalyzer_configuration_save_success_title: '¡La configuración del alcoholímetro se actualizó correctamente!',
  breathalyzer_configuration_save_success_description: 'Consulte las configuraciones actualizadas en los ajustes de abajo.',
  breathalyzer_configuration_save_failed_title: 'Se produjo un problema al actualizar la configuración del alcoholímetro',
  breathalyzer_configuration_save_failed_description: 'Inténtelo de nuevo en un momento.',
  cancel_configuration_title: '¿Cancelar configuración?',
  cancel_configuration_description: 'Ha realizado cambios en la configuración. Al cancelar se descartarán los cambios no guardados. ¿Desea continuar?',
  cancel_configuration_confirm: 'Cancelar configuración',
  driving_configuration: 'Configuración de conducción',
  configuration: 'Configuración',
  input_result: 'Ingresar resultado',
  maximum_alcohol_concentration: 'Concentración de alcohol excesiva',
  breathalyzer: 'Detector de alcohol',
  breathalyzer_page_description:
    'Gestiona todos los resultados del alcoholímetro y sus estándares de configuración en un solo lugar.',
  please_input_a_positive_number_up_to_n_decimal_places:
    'Introduzca un número positivo de hasta {{field}} dígitos después del punto decimal',
  you_must_input: 'Debe ingresar',
  driving: 'Conducir',
  test_time: 'Tiempo de prueba',
  input_type: 'Tipo de entrada',
  list_breathalyzer: 'Analizador de respiración',
  Manual: 'Manual',
  auto: 'Automático',
  Breathalyzer: 'Detector de alcohol',
  you_do_not_have_privilege_to_export_this_report:
    'No tiene derecho a exportar este informe',
  competitor_beer: 'Cerveza competidora',
  split_round: 'Dividir Ronda',
  reset: 'Restablecer',
  how_many_rounds_splitting_do_you_want_to_make:
    '¿Cuántas rondas desea crear al dividir?',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    'No se pueden dividir las rondas que ya han sido divididas o están en curso',
  hide_sample_details: 'Ocultar detalles de la muestra',
  hide_sample_details_auto_hide:
    'SÝ - puede dividir las muestras y mostrar automáticamente toda la información oculta después de probar todas las rondas divididas.',
  hide_sample_details_manual_hide:
    'Manual - no se pueden dividir las muestras y necesita asignar un administrador temporal para cambiar manualmente Mostrar u Ocultar en la página de discusión.',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    'Los datos se ocultarán a los catadores: cervecería, fecha de producción, marca, variedad de malta e ID de muestra',
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split:
    'Esta ronda se selecciona Manual, la función de división no está disponible, puede elegir Auto Ocultar o No Ocultar para dividir.',
  data_will_be_hidden_for_ok_nok:
    'Todos los datos relevantes se ocultarán a los catadores',
  you_can_not_add_duplicate_attributes:
    'No se pueden agregar atributos duplicados.',
  menu: 'Menú',
  link_breathalyzer: 'Vinculado',
  not_link_breathalyzer: 'No conectado',
  breathalyzer_to_link: 'Conectar el analizador de respiración',
  breathalyzer_connection_failed_title: 'Error al conectar el alcoholímetro',
  breathalyzer_connection_failed_desc:
    'Actualiza la página y vuelve a intentarlo.',
  breathalyzer_can_not_to_link_for_this_browser:
    'La función del probador de alcohol fue desarrollada para usar dispositivos de computadora personal en Google chrome.',
  reopen: 'Reabrir',
  round_reopen_message: '¿Está seguro de que desea reabrir la ronda?',
  common_production_line: 'Línea de producción',
  common_packaged_beer_data_code: 'Código de datos de cerveza empaquetada',
  common_masking_process_for_bottles:
    'Proceso de enmascaramiento para botellas',
  common_str_number_days_over_aged: 'Días de envejecimiento excesivo',
  common_over_aged_beer: 'Cerveza envejecida',
  sample_successfully_swapped: 'Muestra intercambiada con éxito.',
  scoring: 'Puntuación',
  configure_available_flavors: 'Configurar sabores disponibles',
  process_check: 'Inspección de proceso',
  new_process_check: 'Nueva inspección de proceso',
  edit_process_check: 'Editar inspección de proceso',
  remove_process_check: 'Eliminar inspección de proceso',
  common_package: 'Paquete',
  common_department: 'Departamento',
  common_shift: 'Turno',
  common_tank: 'Tanque',
  common_oknok: 'OKNOK',
  common_remark: 'Comentarios',
  show_all_process_check: 'Muestra todos los controles de proceso',
  show_all_process_check_help_circle:
    'Muestra los datos creados dentro de medio año a partir de hoy. Marque esta casilla si todavía necesita ver los datos creados dentro de un año a partir de hoy',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    'La fecha de muestreo no puede ser anterior a la hora actual',
  common_job_position: 'Puesto de trabajo',
  decimal_sep: 'Separadores decimales',
  is_swapped_to: 'se intercambia a',
  review_warning_comment_title: '¡Tiene muestras no comentadas!',
  continuous_typing: 'Mecanografía continua',
  continuous_typing_tips:
    "Continúe escribiendo 'Atributo' después de seleccionar 'Intensidad'.",
  BSSI_Reports: 'Informes BSSI',
  data_analysis_sip: 'Análisis de datos - SIP',
  select_the_color: 'Seleccione el color',
  color: 'Color',
  download_document: 'Descargar el documento',
  Month_of_Discontinued_Production: 'Meses fuera de producción',
  Suspension_List: 'Lista de suspensiones',
  New_Suspension: 'Nueva suspensión',
  new_suspension_page: 'Nueva suspensión',
  edit_suspension_page: 'Editar suspensión',
  Brand_name: 'Nombre de marca',
  List_Brewery_Production_Suspension:
    'Lista de suspensiones de producción de cervecerías',
  Upload_successfully: 'Archivo subido con éxito',
  training_materials: 'Materiales de capacitación',
  Remove_Suspension: 'Eliminar suspensión',
  Add_Absence_Reason: 'Añadir el motivo de ausencia',
  Reason: 'Motivo',
  Select_reason: 'Seleccionar motivo',
  You_have_duplicate_absence_dates: 'Tiene fechas de ausencia duplicadas',
  Remove_Absence: 'Eliminar ausencia',
  Absence_Title:
    'Seleccione la hora y el motivo de su ausencia en la cata. Vea o elimine las entradas en Motivo enviado.',
  Shipping_Site: 'Sitio de envío',
  shipping_received: 'Envío recibido',
  receive_sample_alert: '¿Está seguro de haber recibido la muestra?',
  receive_uncheck_alert: '¿Estás seguro de que quieres desmarcarlo?',
  all_received: 'Todo recibido',
  not_all_received: 'No todos recibidos',
  not_for_shipping: 'No para el envío',
  receive_hint: 'Seleccione todos los sitios que recibirán esta muestra',
  absence_reason: 'Motivo de ausencia',
  Page1: 'Página {{field}}',
  Search: 'Buscar',
  page_total: 'Total',
  start_date: 'Fecha de Inicio',
  end_date: 'Fecha de Finalización',
  ok_for_all: 'OK para todos',
  its_mandatory_to_select_sample_A_and_sample_B:
    'Es obligatorio seleccionar la muestra A y la muestra B.',
  its_mandatory_to_select_sample_A: 'Es obligatorio seleccionar la muestra A.',
  its_mandatory_to_select_sample_B: 'Es obligatorio seleccionar la muestra B.',
  triangle_comment: 'Comentario',
  select_sample: 'Selección de la muestra',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    'Filtro de fecha de muestra, predeterminado a los últimos 7 días. Se exporta a Excel basado en este período filtrado.',
  select_all_flavor: 'Seleccionar todos',
  deselect_all: 'Deseleccionar todos',
  email_distribution: 'Destinatarios del informe mensual',
  new_email_distribution: 'Nuevos destinatarios del informe mensual',
  edit_email_distribution: 'Editar destinatarios del informe mensual',
  distribution_type: 'Tipo de distribución',
  the_score_entered_is_invalid:
    'La puntuación introducida no es válida. Consulte la tabla de puntuación y vuelva a introducir su puntuación.',
  service_now:
    'Haga clic para crear un ticket de incidente para reportar un problema y obtener ayuda.',
  service_now_tips:
    'Hola, si observas algún problema o deseas solicitar soporte, puedes hacer clic aquí e informarlo directamente en ServiceNow, nuestro equipo de soporte se pondrá en contacto contigo lo antes posible.',
  done: 'Hecho',
  changes_you_made_may_not_be_saved:
    'Es posible que los cambios que ha hecho no se puedan guardar. ¿ quieres continuar y perder los cambios?',
  cannel_auto_save_tips:
    'Ahora que el rendimiento de la página de degustación ha mejorado, recuerde hacer clic en "completar la muestra" para guardar y enviar los resultados de su degustación.',
  list_email_page_tips:
    'Esta es la instrucción de cómo configurar la muestra correcta de KPI, con el fin de asegurarse de que el informe mensual de zona puede reflejar un análisis exacto para su zona MCS degust.',
  list_email_page_helps:
    'Instrucciones sobre cómo configurar un ejemplo de KPI para reflejar los datos precisos en el informe mensual regional.',
  kpi_instruction: 'Descripción del KPI',
  group_no_recipients_message: 'Se necesita al menos un destinatario.',
  the_current_distribution_type_already_exists:
    'El tipo de distribución actual ya existe, vuelva a seleccionar el tipo o regrese a la lista.',
  distribution_type_message_empty:
    'El tipo de distribución no permite estar vacío o vacío',
  add_samples: 'Añadir muestra(s) a la Ronda',
  copy_this_sample: 'Duplicar la muestra',
  remove_this_sample: 'Eliminar la muestra',
  drag_samples_here: 'Arrastra las muestras aquí',
  drop_here: 'Suelta aquí',
  multiple_selection_tips: `Puede seleccionar varias muestras a la vez para el mismo tipo de muestra. Haga clic en '+' y '-' para probarlo.`,
  all_add_once_tips: `Haga clic en el botón 'Seleccionar todo' para añadir automáticamente 1 muestra a cada tipo de muestra seleccionado.`,
  copy_confirm_tip: '¿Estás seguro de que quieres replicar la muestra?',
  user_non_abi_user: 'Nuevo usuario temporal',
  language_of_email_invitation:
    'Idioma de la invitación por correo electrónico',
  add_non_abi_users_to_round:
    'El usuario temporal recibirá una invitación por correo electrónico con un enlace para asistir a la cata en cuestión.',
  change_non_abi_users_to_round:
    'El catador temporal invitado recibirá una invitación por correo electrónico con un enlace para asistir a esta cata.',
  guest: 'Invitado',
  email_to_all: 'Enviar a todos',
  send_email: 'Enviar invitación por correo electrónico',
  temporary_non_abi_taster: 'Catador temporal',
  user_type: 'Tipo de usuario',
  email_invitation_delivery_request_sent:
    'Solicitud de invitación por correo electrónico enviada.',
  incorrect_e_mail_formatting: 'Formato incorrecto del correo electrónico',
  all_tasters: 'Todos los catadores',
  tasters: 'Catadores',
  key_tasters: 'Catadores principales',
  non_key_tasters: 'Catadores no principales',
  taster_already_started_cannot_change:
    'El catador ya ha comenzado, no se puede cambiar',
  temporary: 'Usuario temporal',
  maximum_number_of_samples_is: 'El número máximo de muestras es',
  sample_added: 'Muestra añadida',
  click_to_view_scale_of_flavour_intensities:
    'Haga clic en el enlace para ver las escalas de intensidad detalladas',
  list_next_week_plan: 'Plan de la próxima semana',
  common_time_zone: 'Zona horaria',
  common_last_response_time: 'Última hora de respuesta',
  new_week_plan: 'Nuevo Plan Semanal',
  invited_week: 'Semana Invitada',
  email_language: 'Idioma del Email',
  save_and_send_email: 'Guardar y Enviar Email',
  common_start_time: 'Hora de inicio',
  common_end_time: 'Hora de finalización',
  session_name_email_subject:
    'Nombre de la sesión / Asunto del correo electrónico',
  location: 'Ubicación',
  edit_week_plan: 'Editar Plan Semanal',
  email_response: 'Email de respuesta',
  round_remove_plan: '¿Está seguro de que desea eliminar el plan?',
  view_week_plan: 'Ver Plan Semanal',
  are_you_confirming_to_send_the_confirmation_email:
    '¿Está confirmando el envío del correo electrónico de confirmación?',
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation:
    'Cada 10 minutos el sistema actualizará la respuesta por correo electrónico de la invitación al plan de la semana siguiente',
  documents_upload_tips: 'La carga de archivos sólo admite {{field}}',
  ignore_submit: 'Ignorar&Enviar',
  if_count_as_kpi:
    'Si cuenta como KPI, la muestra se guardará en el historial de muestra',
  confirmed_count: 'Recuento confirmado',
  accepted: 'Aceptado',
  declined: 'Rechazado',
  no_response: 'Sin respuesta',
  reminder_time: 'Hora del recordatorio',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    '¿Está seguro de que desea eliminar la hora de inicio/fin de sesión que ha seleccionado y cambiar a otra semana invitada?',
  apply_to_all_sessions_location_tasters: `Aplicar 'Ubicación' y 'Catadores' a las siguientes sesiones`,
  round_samples_shuffle_confirm: '¿Seguro que quieres barajar los Sets?',
  all_count_as_kpi: 'Todos cuentan como KPI',
  msc_tasting_tour_mask:
    'El sistema identificará automáticamente el Código KPI relacionado basándose en la muestra contada con el Mes KPI correcto, por lo que NO tendrá que dividir diferentes marcas en una ronda.',
  competition: 'Concurso',
  copy_link: 'Copiar enlace',
  open_link: 'Abrir enlace',
  common_download_img: 'Descargar IMG',
  please_select_taster: 'Seleccione un catador',
  user_principal_name: 'Nombre principal de usuario',
  user_status: 'Estado del usuario',
  termination_date: 'Fecha de finalización',
  function_level: 'Nivel de función',
  last_update_time: 'Hora de última actualización',
  system_related: 'Relacionado con el sistema',
  workday_related: 'Relacionado con WorkDay',
  employee_id: 'ID de empleado',
  zitec_project_name: 'Nombre del proyecto',
  applicant: 'Solicitante',
  applicant_date: 'Fecha de solicitud',
  test_method: 'Método de ensayo',
  liquid_category: 'Categoría de líquido',
  conditions: 'Condiciones',
  time_points: 'Puntos temporales',
  execution_date: 'Fecha de ejecución',
  execution_by_time_points: 'Fecha de ejecución calculada por puntos horarios',
  invitation_start_time: 'Hora de inicio de la invitación',
  invitation_end_time: 'Hora de finalización de la invitación',
  invitation_reminder: 'Recordatorio de invitación',
  application_form: 'Formulario de solicitud',
  application_form_result: 'Resultado de la solicitud',
  upload_result: 'Subir resultado',
  zitec_sessions: 'Sesiones ZITEC',
  zitec_id: 'ZITEC ID',
  new_zitec_session: 'Nueva Sesión ZITEC',
  common_search_applicant: 'Buscar Solicitante',
  history_record: 'Historial',
  common_quarterly: 'Trimestral',
  common_month: 'Mes',
  kpi_report: 'Informe KPI',
  kpi_result: 'Archivo Anaplan',
  action_log: 'Registro de acciones',
  validate_data: 'Datos verificados',
  push_anaplan_window_open_date:
    'Fecha de apertura de la ventana Push Anaplan:',
  unLock_kpi: 'Desbloquear KPI',
  lock_kpi: 'Bloquear KPI',
  locked: 'Bloqueado',
  unlocked: 'Desbloqueado',
  menu_kpi_lock: 'Bloqueo KPI',
  freshness_kpi_lock: 'Bloqueo Frescura',
  in_profile_kpi_lock: 'Bloqueo In-Profile',
  are_you_sure_you_want_to_lock_kpi:
    '¿Está seguro de que desea bloquear KPI para {{field}}?',
  are_you_sure_you_want_to_unlock_kpi:
    '¿Está seguro de que desea desbloquear el KPI {{field}}?',
  lock_kpi_month_zone:
    'Su operación está restringida debido al bloqueo de muestras de KPI activadas en un mes y región de KPI dados. Si tiene alguna pregunta, Póngase en contacto con el propietario de su área para obtener más detalles sobre el bloqueo de datos kpi.',
  lock_freshness_kpi_month_zone:
    'Su operación está restringida debido al bloqueo de muestras de KPI activadas en un trimestre y región de KPI dados. Si tiene alguna pregunta, Póngase en contacto con el propietario de su área para obtener más detalles sobre el bloqueo de datos kpi.',
  submit_timeout: 'Error al enviar, por favor intente nuevamente más tarde!',
  anaplan_un_upload_tips:
    '¡Espere a que se abra la siguiente ventana de Anaplan!',
  anaplan_un_confirm_tips: '¡¡ por favor, confirme los datos KPI del mes dado!',
  confirmed: 'Confirmado',
  confirm_data: 'Confirmar Datos',
  flavor_groups: 'Grupos de sabores',
  compound: 'Compuesto',
  sit_code_not_exist:
    'Este código de asiento no existe, por favor tenga en cuenta el formato de código de asiento como 001, 002.',
  sit_code_chose:
    'Este código de asiento ha sido elegido, por favor introduzca el código de asiento correcto.',
  kpi_lock: 'Bloqueo de KPI',
  kpi_confirmation: 'Confirmación de KPI',
  global_kpi_lock: 'Bloqueo KPI Global',
  select_month: 'Seleccione un mes',
  need_to_wait_global_lock: 'Hay que esperar a que se bloquee globalmente.',
  monthly_kpi_locked_zones: 'KPI mensual Zonas bloqueadas',
  flavor_confirm_save: `Los sabores '{{field}}' no seleccionados se encuentran en las muestras añadidas. Si confirma que desea guardar la configuración de sabores actual, se eliminarán las muestras correspondientes`,
  temporary_admin: 'Administrador temporal',
  unhide_sample_details: 'Desocultar detalles de la muestra',
  hide_sample: 'Ocultar muestra',
  download_report_timeout_error_message:
    'Tiempo de acceso agotado, por favor compruebe la conexión de red.',
  you_can_only_select_up_to:
    'Sólo puede seleccionar hasta {{field}}, por favor reduzca el número de opciones.',
  push_anaplan: 'Push Anaplan',
  pushed: 'Push Finalización',
  self_evaluation_report:
    'Haga clic para descargar el informe de autoevaluación',
  date_range: 'Intervalo de fechas',
  kpi_month_range: 'KPI Mes Rango',
  quick_select: 'Selección rápida',
  current_month: 'Mes en curso',
  current_year: 'Año actual',
  a_whole_year: 'Todo un año',
  download_self_evaluation_report: 'Descargar el informe de autoevaluación',
  select_tasters: 'Seleccionar catadores',
  create_ticket: 'Crear Ticket',
  sensory_intelligent_platform: 'Plataforma Inteligente Sensory - PBI',
  external_links: 'Enlaces externos',
  evaluation_report: 'Informe de evaluación',
  download_evaluation_report: 'Descargar informe de evaluación',
  taster_type: 'Tipo de catador',
  taster_evaluation_tip:
    'Ahora puedes hacer clic aquí para descargar tu Informe de Autoevaluación.',
  admin_evaluation_tip:
    'Ahora puede hacer clic aquí para descargar el informe de evaluación de los catadores.',
  kpi_sample: 'Muestra de KPI',
  add_to_download_list: 'Añadir a lista de descargas',
  to_download_list: 'Para descargar',
  selected_tasters: 'Catadores seleccionados',
  generation_time: 'Tiempo de generación',
  start_month: 'Mes de inicio',
  end_month: 'Mes de finalización',
  download_all: 'Descargar todo',
  new_physchem_tips:
    'Ahora puede hacer clic aquí para añadir las propiedades físico-químicas de la muestra',
  view_physchem_tips:
    'Ahora puede hacer clic aquí para ver las propiedades físico-químicas de las muestras de la ronda actual',
  physchem_disabled_tips:
    'No se puede ver phychem cuando las muestras están ocultas.',
  package_code: 'Código del envase',
  concentration_at_fu: 'Concentración a 1 unidad de sabor',
  base_beer: 'Cerveza Base',
  flavor_intensities_scale: 'Escala de intensidades de sabor',
  flavor_unit: 'Unidad de sabor',
  add_a_sample: 'Añadir una muestra',
  common_kpi_quarter: 'KPI Trimestre',
  sample_duplicated_quarter_kpi_message:
    'Ya existe un KPI para el trimestre, la marca y el sitio que ha seleccionado, por lo que no podrá guardarlo.',
  select_quarter: 'Seleccionar trimestre',
  please_select_kpi_quarter: 'Seleccione el trimestre del KPI',
  error_fields: 'Campos de error',
  your_answer: 'Tu respuesta',
  preference: 'Preferencias',
  please_select_preference_group:
    'Debe seleccionar sus preferencias antes de enviar el formulario!',
  monthly_report: 'Informe mensual',
  draft: 'Borrador',
  confirm_send: 'Confirmar y enviar',
  sent_completion: 'Enviado',
  send_draft: 'Enviar borrador',
  send_draft_monthly_report:
    'Enviar el informe mensual a su dirección de correo electrónico.',
  please_confirm_the_recipients:
    'Confirme los destinatarios del informe mensual',
  total_recipients: 'Total de destinatarios',
  sending: 'Enviando',
  sending_monthly_report_tips1: `Su solicitud se está procesando.`,
  sending_monthly_report_tips2: `Compruebe el resultado en el «Registro de acciones».`,
  configure_upgrade_center: 'Configurar el Centro de Actualizaciones',
  sprint_content: 'Contenido del Sprint',
  release_date: 'Fecha de Lanzamiento',
  add_sprint: 'Añadir Sprint',
  sprint_meterials: 'Materiales del Sprint',
  upgrade_center: 'Centro de Actualizaciones',
  function: 'Función',
  my_evaluation_report: 'Mi informe de evaluación',
  upgrade_center_remove_sprint_number:
    'Está seguro de que desea eliminar este número de sprint',
  sprint_version_tips: 'Haga clic para ver los materiales del sprint.',
  edit_sprint: 'Editar Sprint',
  new_sprint_tips:
    'Ahora puede hacer clic aquí para ver los materiales del sprint.',
  production_date_range: 'Rango de fechas de producción',
  preparation: 'Preparación',
  panel: 'Panel',
  session: 'Sesión',
  product: 'Producto',
  attribute: 'Atributo',
  common_menu_samples: 'Muestras',
  common_menu_rounds: 'Rondas',
  common_menu_groups: 'Grupos',
  common_menu_suspension_list: 'Suspensión',
  common_menu_planning_week_sessions: 'Sesiones de planificación semanal',
  common_menu_zitec_sessions: 'Sesiones ZITEC',
  common_menu_brands: 'Marcas',
  common_menu_kpi_brands: 'Marcas KPI',
  common_menu_packages: 'Paquetes',
  common_menu_styles: 'Estilos',
  common_menu_malt_variety: 'Variedad de malta',
  common_menu_intensities: 'Intensidades',
  common_menu_categories: 'Categorías',
  common_menu_attributes: 'Atributos',
  common_menu_user_management: 'Gestión de usuarios',
  common_menu_role_management: 'Gestión de roles',
  common_menu_permission_control: 'Control de permisos',
  system: 'Sistema',
  select_taste_type: 'Seleccionar tipo de degustador',
  select_round: 'Seleccionar Ronda',
  a_previous_request_is_still_being_processed:
    'Una solicitud anterior aún se está procesando. Inténtelo de nuevo más tarde.',
  select_item: 'Seleccionar {{field}}',
  common_new_kpi_brand_button: 'Nueva KPI brand',
  common_target: 'Objetivo',
  common_focus_brands: 'Marcas de Enfoque',
  common_strategic_brands: 'Marcas Estratégicas',
  kpi_brands_new_page_description:
    'Interfaz de Creación de Nueva KPI Brand, con funciones para completar información de KPI Brand, enviar y guardar.',
  kpi_brands_edit_page_description:
    'Editar interfaz de KPI Brand, con funciones para actualizar, enviar y guardar información de KPI Brand.',
  kpi_brands_edit_page_description_prefix: 'Ver y configurar KPI Brands para ',
  kpi_brands_page_description:
    'Interfaz de gestión de KPI Brands, con funciones de visualización, envío y revisión.',
  table_apply: 'Aplicar',
  table_clear: 'Limpiar',
  table_search: 'Buscar',
  table_enter_to_filter: 'Escribir para filtrar...',
  table_select_to_filter: 'Seleccionar para filtrar...',
  table_select_all: 'Seleccionar todo',
  table_select_all_aria: 'Seleccionar todas las filas',
  table_select_row_aria: 'Seleccionar fila',
  table_filter_by: 'Filtrar por',
  table_clear_filters: 'Limpiar filtros',
  table_reset_filters: 'Restablecer filtros',
  table_no_results_for_filters: 'No se encontraron resultados para los filtros aplicados.',
  table_items_selected: 'elementos seleccionados',
  table_sort: 'Ordenar',
  table_sort_toggle: 'Haga clic para alternar la ordenación',
  table_no_options: 'No hay opciones disponibles',
  table_reset: 'Restablecer',
  table_all: 'Todos',
  table_no_results: 'No se encontraron resultados para los filtros aplicados',
  common_approved_at: 'Aprobado el {{date}}',
  common_rejected_at: 'Rechazado el {{date}}',
  kpi_status_created: 'Creado',
  kpi_status_waiting_for_approval: 'Esperando aprobación',
  kpi_status_approved: 'Aprobado',
  kpi_status_rejected: 'Rechazado',
  kpi_action_approve: 'Aprobar',
  kpi_action_reject: 'Rechazar',
  common_by_user: 'por {{user}}',
  pagination_aria_label_next_page: 'Ir a la página siguiente',
  pagination_aria_label_previous_page: 'Ir a la página anterior',
  pagination_aria_label_first_page: 'Ir a la primera página',
  pagination_aria_label_last_page: 'Ir a la última página',
  pagination_aria_label_input:
    'Ingrese la página que desea, de 1 a {totalItems}',
  pagination_aria_label_items_per_page:
    '{pageSize} elementos por página seleccionados, haga clic para cambiar',
  pagination_lines_per_page: 'Líneas por página',
  pagination_total_pages: 'de {totalPages}',
  pagination_total_elements:
    '{firstItem}-{lastItem} de {totalItems} resultados',
  pagination_no_results: 'No se encontraron resultados',
  kpi_brand_successfully_saved: '¡KPI brand guardado con éxito!',
  kpi_brand_saved_description:
    'Compruébelo en la KPI brand a continuación. Este es solo un guardado temporal, la presentación de aprobación aún no se ha completado.',
  kpi_brand_failed_to_save: 'Error al guardar KPI brand.',
  kpi_brand_save_failed_description:
    'Por favor, inténtelo de nuevo en un momento.',
  kpi_brand_successfully_submitted: '¡KPI brand creada con éxito!',
  kpi_brand_submitted_description:
    'Compruébalo en la KPI brand de abajo. Por favor, consulta el progreso de aprobación en la página de detalles; esta KPI brand estará disponible solo después de la aprobación.',
  kpi_brand_failed_to_submit: 'Error al crear KPI brand.',
  kpi_brand_submit_failed_description:
    'Por favor, inténtelo de nuevo en un momento.',
  flavor_id_discussion: 'Discusión de identificación de sabores',
  view_and_discussion_for: 'Ver y discutir para',
  common_cup: 'Taza',
  tasters_joined: 'Catadores participantes',
  tasters_all_correct: 'Catadores con todo correcto',
  total_accuracy: 'Precisión total',
  accuracy: 'Precisión',
  all_correct: 'Todo correcto',
  otherwise: 'Otros',
  result: 'Resultado',
  Key: 'Principal',
  nonkey: 'No principal',
  common_guest: 'Invitado',
  view_correct_answers: 'Ver respuestas correctas',
  hide_correct_answers: 'Ocultar respuestas correctas',
  change_to_table: 'Cambiar a tabla',
  change_to_card: 'Cambiar a tarjetas',
  not_answered: 'Sin responder',
  actions: 'Acciones',
  actions_page_description:
    'Ver todas las Acciones creadas por los usuarios durante la sesión de degustación.',
  action_created_by: 'Creado por',
  my_actions: 'Mis Acciones',
  action_list_info: 'La acción se creará después de cerrar la ronda.',
  unsaved_changes_warning:
    'Tiene cambios sin guardar. ¿Está seguro de que desea salir?',
  common_go_back: 'Volver',
  cancel_create_action_title: '¿Cancelar la creación de la acción?',
  cancel_edit_action_title: '¿Cancelar la edición de la acción?',
  cancel_create_action_confirm: 'Cancelar la creación de la acción',
  cancel_edit_action_confirm: 'Cancelar la edición de la acción',
  unsaved_changes_description:
    'Ha introducido contenido en el formulario. Al cancelar se perderán todos los datos no guardados. ¿Desea continuar?',
  unsaved_changes_edit_description:
    'Ha cambiado el contenido del formulario. Al cancelar se perderán todos los cambios no guardados. ¿Desea continuar?',
  action_update_failed_desc: 'Vuelva a intentarlo en unos instantes.',
  action_change_status_successfully: '¡Estado cambiado!',
  action_change_status_successfully_desc:
    'El estado de la acción cambió a {{status}}.',
  action_change_status_failed: 'No se pudo cambiar el estado',
  action_change_status_failed_desc:
    'No se pudo cambiar el estado de la acción. Vuelva a intentarlo.',
  download_report_success: '¡Informes descargados correctamente!',
  download_report_success_desc: 'Consúltelos en la carpeta de descargas.',
  download_self_evaluation_report_success:
    '¡Informe de autoevaluación descargado correctamente!',
  download_report_failed: 'No se pudieron descargar los informes.',
  download_report_failed_desc: 'Vuelva a intentarlo dentro de un momento.',
  evaluation_report_add_success: '¡Informe añadido correctamente!',
  evaluation_report_add_success_desc:
    "Consúltelo en el informe de evaluación 'Para descargar'.",
  evaluation_report_add_failed: 'No se pudo añadir el informe.',
  evaluation_report_add_failed_desc:
    'Vuelva a intentarlo dentro de un momento.',
  add_taster: 'Añadir catador',
  alcohol_concentration_result: 'Resultado de concentración de alcohol',
  absence_save_success: '¡Motivo de ausencia añadido correctamente!',
  absence_save_success_desc: 'Consúltelo en las ausencias enviadas.',
  submitted_absence: 'Ausencias enviadas',
  no_absence_to_show: 'No hay ausencias para mostrar',
  absence_delete_success: '¡Motivo de ausencia eliminado correctamente!',
  absence_delete_success_desc: 'Consulte la lista actualizada en las ausencias enviadas.',
  absence_delete_confirm_title: '¿Eliminar ausencia?',
  absence_delete_confirm_description: 'El registro de ausencia [{{start}} - {{finish}}] se eliminará permanentemente. ¿Desea continuar?',
  absence_delete_confirm_delete: 'Eliminar',
  absence_save_failed: 'No se pudo añadir el motivo de ausencia',
  absence_save_failed_desc: 'Vuelva a intentarlo dentro de un momento.',
  absence_duplicate_date_desc:
    'Ya existe un registro de ausencia para la fecha seleccionada. No se permiten envíos duplicados.',
  absence_delete_failed: 'No se pudo eliminar el motivo de ausencia',
  absence_delete_failed_desc: 'Vuelva a intentarlo dentro de un momento.',
  role_management_change_role: 'Cambiar rol',
  role_management_reset_success: '¡Permisos restablecidos correctamente!',
  role_management_reset_success_desc: 'Los permisos de este rol se han restablecido a la configuración predeterminada.',
  role_management_reset_failed: 'No se pudieron restablecer los permisos.',
  role_management_reset_failed_desc: 'Vuelva a intentarlo dentro de un momento.',
  role_management_switch_role_title: '¿Descartar cambios?',
  role_management_switch_role_description: 'Hay cambios de permisos sin guardar. Cambiar de rol los descartará. ¿Desea continuar?',
  role_management_switch_role_confirm: 'Cambiar rol',
  role_management_created: '¡Rol personalizado creado correctamente!',
  role_management_created_desc: 'Consúltalo en el control de permisos de abajo.',
  role_management_permissions_failed: 'No se han podido cargar los permisos.',
  role_management_create_failed: 'No se ha podido crear el rol.',
  role_management_create_required: 'Introduce un nombre de rol y selecciona un conjunto de permisos.',
  role_management_create_failed_desc: 'Inténtalo de nuevo dentro de un momento.',
  role_management_save_success: '¡Permisos del rol actualizados correctamente!',
  role_management_save_success_desc: 'Los cambios se han guardado. Puedes revisarlos en el control de permisos de abajo.',
  role_management_save_failed: 'No se han podido guardar los cambios del rol.',
  role_management_save_failed_desc: 'Inténtalo de nuevo dentro de un momento.',
  role_management_permission: 'Función',
  role_management_view: 'Ver',
  role_management_edit: 'Editar',
  role_management_approve: 'Aprobar',
  role_management_search: 'Buscar roles',
  role_management_current_role_prefix: 'Tu rol actual es',
  role_management_create: 'Crear rol personalizado',
  role_management_save_changes: 'Guardar cambios',
  common_apply: 'Aplicar',
  role_management_reset_title: '¿Restablecer los permisos predeterminados?',
  role_management_reset_description: 'Esto restablecerá los permisos del rol a la configuración predeterminada y eliminará todos los cambios manuales. Esta acción no se puede deshacer.',
  cancel_create_role_title: '¿Cancelar la creación del rol personalizado?',
  cancel_create_role_confirm: 'Cancelar creación del rol',
  cancel_create_role_description: 'Has introducido datos en el formulario. Al cancelar se descartarán todos los datos no guardados. ¿Quieres continuar?',
  role_management_delete_title: '¿Eliminar el rol personalizado?',
  role_management_default_role: 'el rol predeterminado',
  role_management_delete_preview_no_users: 'El rol personalizado «{{role}}» se eliminará permanentemente. ¿Quieres continuar?',
  role_management_create_title: 'Crear rol personalizado',
  role_management_role_name: 'Nombre del rol',
  role_management_permission_set: 'Conjunto de permisos para personalizar',
  role_management_role_name_placeholder: 'Introduce el nombre del rol',
  role_management_permission_set_placeholder: 'Selecciona un conjunto de permisos',
  role_management_reset_success: '¡Permisos restablecidos correctamente!',
  role_management_reset_success_desc: 'Los permisos de este rol se han restablecido a la configuración predeterminada.',
  role_management_reset_failed: 'No se han podido restablecer los permisos.',
  role_management_reset_failed_desc: 'Inténtalo de nuevo dentro de un momento.',
};
